import { Component } from '@angular/core';
import { MENU_ITEMS } from '../../pages-menu';
import { NbMenuItem } from '@nebular/theme';
import { Page } from '../../administaration/PageRoles/Model/pageRoles';
import { UserService } from '../../administaration/ProfileInfo/Services/UserProfileService';

export const EN_TRANSLATIONS = {
  found: 'found',
  'not found': 'not found',
};

@Component({
  template: ` <router-outlet></router-outlet> `,
})
export class WorkFlowComponent {

  // translationsUrl = './translation/';

  // constructor(private translate: TranslateService) {
  //   this.translate.setDefaultLang('en');
  //   this.translate.use('de');
  //   this.translate.setTranslation('en', EN_TRANSLATIONS);
  // }
}
